import { RoutesDefinition, RouteDefinition } from '../interface/auth.interface';
import { Privileges } from '../enum/auth.enum';

export function getDefinitionByPath(pathName: string) {
  return routesDefinition.reduce<Partial<RouteDefinition>>((routeFinded, section) => {
    const result = section.routes.find((route) => route.path === pathName);
    if (result) {
      return result;
    }
    return routeFinded;
  }, {});
}

export function getRequiredPrivilegeByPath(pathName: string): Privileges {
  return routesDefinition.reduce<Privileges>((requiredPrivilege, section) => {
    const result = section.routes.find((route) => route.path === pathName);
    if (result) {
      if (result.requiredPrivilege) {
        return result.requiredPrivilege;
      }
    }
    return requiredPrivilege;
  }, '_SUPER_ADMIN');
}

export const routesDefinition: RoutesDefinition = [
  {
    title: 'Solicitar',
    routes: [
      {
        name: 'Crear solicitud nueva licencia',
        path: '/license/new',
        requiredPrivilege: 'LICENSE REQUEST',
      },
      {
        name: 'Renovar una licencia',
        path: '/license/renew',
        requiredPrivilege: 'LICENSE RENEW',
      },
      {
        name: 'Ampliar una licencia',
        path: '/license/extend',
        requiredPrivilege: 'LICENSE EXTEND',
      },
    ],
  },
  {
    title: 'Aprobar solicitudes',
    routes: [
      {
        name: 'Listado de solicitudes a aprobar',
        path: '/license/approve',
        requiredPrivilege: 'APPROVAL LIST',
      },
      {
        name: 'Delegar aprobaciones',
        path: '/delegate',
        requiredPrivilege: 'APPROVAL DELEGATE',
      },
      {
        name: 'Actualizar licencia mina',
        path: '/license/mine',
        requiredPrivilege: 'APPROVAL UPDATE_MINE_LICENSE',
      },
    ],
  },
  {
    title: 'Verificación',
    routes: [
      {
        name: 'Verificar estado de licencia',
        path: '/verification/licenses',
        requiredPrivilege: 'VERIFICATION_MY_PROFILE VIEW_LICENCE_STATUS',
      },
      {
        name: 'Verificar infracciones',
        path: '/verification/infractions',
        requiredPrivilege: 'VERIFICATION_MY_PROFILE VIEW_INFRINGEMENT_STATUS',
      },
      {
        name: 'Verificar estado de solicitud',
        path: '/verification/requests',
        requiredPrivilege: 'VERIFICATION_MY_PROFILE VIEW_REQUEST_STATUS',
      },
    ],
  },
  {
    title: 'Infracciones',
    routes: [
      {
        name: 'Ingresar una infracción',
        path: '/infractions',
        requiredPrivilege: 'INFRINGEMENT CREATE',
      },
      {
        name: 'Buscar infracciones',
        path: '/search/infraction',
        requiredPrivilegesOr: [
          'SEARCH INFRINGEMENT',
          'INFRINGEMENT SEARCH',
        ],
      },
      {
        name: 'Ver informe de infracciones',
        path: '/reports/infractions',
        requiredPrivilege: 'REPORT INFRINGEMENT',
      },
    ],
  },
  {
    title: 'Informes',
    routes: [
      {
        name: 'Ver reportes de licencias',
        path: '/reports/licenses',
        requiredPrivilege: 'REPORT LICENSE',
      },
      {
        name: 'Ver reportes de infracciones',
        path: '/reports/infractions',
        requiredPrivilege: 'REPORT INFRINGEMENT',
      },
      {
        name: 'Ver reportes de solicitudes',
        path: '/reports/requests',
        requiredPrivilege: 'REPORT REQUEST',
      },
      {
        name: 'Ver licencias eliminadas',
        path: '/license/show-deleted',
        requiredPrivilege: 'REPORT REQUEST',
        hidden: true, // no la muestra en el navbar
      },
    ],
  },
  {
    title: 'Mis tareas',
    routes: [
      {
        name: 'Tareas pendientes',
        path: '/tasks',
        requiredPrivilege: 'PENDING_TASKS',
      },
    ],
  },
  {
    title: 'Buscar',
    routes: [
      {
        name: 'Buscar conductor',
        path: '/search/driver',
        requiredPrivilegesOr: [
          'SEARCH DRIVER',
          'APPROVAL SEARCH',
        ],
      },
      {
        name: 'Buscar infracción',
        path: '/search/infraction',
        requiredPrivilegesOr: [
          'SEARCH INFRINGEMENT',
          'INFRINGEMENT SEARCH',
        ],
      },
      {
        name: 'Buscar historial',
        path: '/search/requests',
        hidden: true, // no la muestra en el navbar
        requiredPrivilegesOr: [
          'SEARCH DRIVER',
          'APPROVAL SEARCH',
          'SEARCH INFRINGEMENT',
          'INFRINGEMENT SEARCH',
        ],
      },
    ],
  },
];
